/* Contains all application constants */

export const DEFAULT_LOCALE = 'fr-FR';

export const ThemaDiffusionTimeRange = {
  minHours: 3,
  maxHours: 29,
  minMinutes: 0,
  maxMinutes: 59,
};

export const ThemaBreakCodeRange = {
  minHours: 3,
  maxHours: 27,
  minMinutes: 0,
  maxMinutes: 99,
};

export const NbcId = '2';

export const BatchUpdateFileType = {
  grid: 1,
  gridContext: 2,
  gridContextWeekType: 3,
  pricesWeekType: 4,
};

export const TvFileStatus = {
  abandoned: 4,
  done: 2,
};

export const commitmentCategoryOrder = ['Classique', 'Digital', 'Parrainage'];

export const RegGroupId = 'F';

export const ScreenStatus = {
  close: 2,
  open: 3,
  inactive: 4,
  broadcastIncident: 5,
};

export const PriceListType = {
  themaMeasured: 1,
  themaNotMeasured: 2,
};

export enum PriceListLogStatus {
  IntegrationAndFileVerification = '1.0',
  SettingBeforeCalc = '2.0',
  PricesSimulationMainGrid = '3.0',
  PricesSimulationCaptifGrid = '4.0',
  PricesSimulationInternationalGrid = '5.0',
  FinishedWithSuccess = '6.0',
  Canceled = '0.0',
}

export enum FileIntegrationAndVerifStatus {
  InProgress = 0,
  Finished = 1,
  ProcessedWithErrors = -1,
}

export enum ChannelId {
  REG_LIST = 999,
  NAT_REG = 998,
  SO_PRIME = 997,
  NOA = 141,
  VIA_STELLA = 129,
}

export const ChannelF3Nat = {
  id: 1,
  name: 'FRANCE 3',
  channelCode: '3',
  regionCode: 'NAT',
  isRegion: false,
  logo: 'https://s3.eu-west-1.amazonaws.com/tv.francetvpub.fr/assets/images/logo_channel/3.png',
  isFavorite: false,
  nomRegie: 'FRANCE TELEVISIONS PUBLICITE',
  editorName: '',
  isNbc: false,
  priceListCreationTypeId: null,
  batchUpdateFileTypes: [],
};

export enum EnvironmentLabels {
  dev = 'DÉVELOPPEMENT',
  recettePo = 'RECETTE PO',
  recetteUt = 'RECETTE',
  prod = 'PRODUCTION',
}
